/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {SessionService} from "../../services/session.service";

import {CustomErrors} from "../../constant/custom-errors";
import {NgxSpinnerService} from 'ngx-spinner';


import {SignerService} from "../../services/signer.service";
import {forEach} from "angular";

import {HttpService} from 'src/app/http/http.service';
import {Steps} from 'src/app/constant/steps';
import {SessionDto} from "../../model/sessionDto";
import {EvidenceDto} from "../../model/evidenceDto";
import {forkJoin} from 'rxjs';
import {RootScopeService} from "../../services/rootscope.service";
import {RedirectionService} from "../../services/redirection.service";
import {LangKeyService} from "../../services/lang-key.service";
import {SignerDto} from "../../model/signerDto";
import ExternalSignerStatusEnum = SignerDto.ExternalSignerStatusEnum;
import ExternalSessionStatusEnum = SessionDto.ExternalSessionStatusEnum;


@Component({
    selector: 'app-session',
    templateUrl: './session.component.html'
})
export class SessionComponent implements OnInit {


    private sessionService: SessionService;
    private sessionId: string | null = null;
    private signers: any;
    private evidenceRequirementVerifications: any = [];
    private requiresEvidences = false;
    private spinner: NgxSpinnerService;
    public errorMsg: string = '';
    private shortId: string | null = null;


    constructor(private route: ActivatedRoute, private router: Router, sessionService: SessionService, private rootScope: RootScopeService, spinner: NgxSpinnerService, private redirectionService: RedirectionService, private langKeyService: LangKeyService, private signerService: SignerService, private httpService: HttpService) {
        console.log("session component");

        this.sessionService = sessionService;
        this.spinner = spinner;

    }

    ngOnInit(): void {
        console.log("init session component");
        // put token in local storage and remove query param
        let token;

        var snapshot = this.route.snapshot;
        let params = {...snapshot.queryParams};

        token = params['token'];

        if (token) {
            console.debug('Putting token in session storage: ', token);
            sessionStorage.setItem('token', token);
            //TODO check if used
            delete params['token'];
            this.router.navigate([], {queryParams: params}).then(() => this.ngOnInit());
            return;
        }

        this.rootScope.get().step = undefined;
        console.debug('continue without token');
        // Enable spin
        this.spinner.show('spinner');
        // Get the sessionId from parameters

        this.route.params.subscribe(params => {
            this.sessionId = params['sessionId'];
        });
        if (!this.sessionId) {
            this.sessionId = sessionStorage.getItem('sessionId');
        }

        this.shortId = sessionStorage.getItem('shortId');
        console.info('-----sessionId : ' + this.sessionId + '/ shortId : ' + this.shortId);

        //update properties with session front Config
        this.sessionService.updateProperties(this.sessionId).then(() => {
            // Update the sessionId
            this.sessionService.id = this.sessionId;
            this.sessionService.info = undefined;
            this.getSessionInfo();
        })
    }

    // Get Sessions info
    getSessionInfo() {

        var params = {
            sessionId: this.sessionId
        };

        console.debug('Getting session info: ' + params.sessionId);

        //prevent unreachable server error when no session
        if (typeof params.sessionId === 'undefined') {
            this.redirectionService.error(this.route, CustomErrors.invalidSession, CustomErrors.invalidSession);
            return;
        }

        // define process steps for breadcrumb
        let that = this;
        //get the current step
        that.httpService.getSession(this.sessionId!).toPromise()
            .then(function (response) {
                    console.log("Getting session response =", response);
                    if (response?.success) {
                        // If no error
                        // Save sessions info
                        let sessionDto: SessionDto = response.result as SessionDto;
                        that.sessionService.info = sessionDto;

                        //set default locale
                        if (that.sessionService.info && that.sessionService.info.configDto.defaultLocale) {
                            that.langKeyService.setDefaultLocale(that.sessionService.info.configDto.defaultLocale);
                        }
                        that.langKeyService.setLocale(that.sessionService.info.local);
                        console.debug('sessions status : ', sessionDto.externalSessionStatus);

                        switch (response.result && sessionDto.externalSessionStatus) {
                            case ExternalSessionStatusEnum.Init:
                                // Clean the storage at the beginning of the session
                                sessionStorage.removeItem('personalDataConsent');
                                that.getSigners();
                                break;
                           // case ExternalSessionStatusEnum.resumeEmailKo: TODO : see why don't exist un status generated
                            case ExternalSessionStatusEnum.Completed:
                                //ending
                                switch (that.rootScope.get().properties.summaryPage) {
                                    case 'redirection':
                                        that.redirectionService.exit(that.sessionService.getUrlOk());
                                        break;
                                    case 'redirectionPage':
                                        that.redirectionService.transientSummary(that.route, that.sessionId);
                                        break;
                                    case 'page':
                                        that.redirectionService.summary(that.route, that.sessionId);
                                        break;
                                    default:
                                        that.redirectionService.summary(that.route, that.sessionId);
                                        break;
                                }

                                break;
                            case ExternalSessionStatusEnum.Canceled:
                                var urlCancel = that.sessionService.info.urlCancel;
                                if (urlCancel) {
                                    that.redirectionService.exit(that.sessionService.getUrlCancel());
                                } else {
                                    that.redirectionService.cancel(that.route, that.sessionId);
                                }
                                break;
                            case ExternalSessionStatusEnum.Error:
                                that.redirectionService.error(that.route, CustomErrors.unknownError, that.sessionId);
                                break;
                            default:
                                // Log the error and redirect
                                console.warn('invalid ExternalSessionStatus : ' + sessionDto.externalSessionStatus);
                                that.redirectionService.error(that.route, CustomErrors.invalidSession, that.sessionId);
                                break;
                        }
                    } else {

                        console.log("process error")
                        // If process error
                        //handle session errors here ## tricky
                        if (response?.error?.errorCode === 8) {
                            that.redirectionService.error(that.route, CustomErrors.invalidSession, CustomErrors.invalidSession);
                        } else {
                            that.redirectionService.error(that.route, CustomErrors.unexpectedError, that.sessionId);
                        }
                    }

                }, function () {
                that.redirectionService.error(that.route, CustomErrors.unreachableService, that.sessionId);
                }
            ).then(() => that.getSignerInfo());


    }

    // get signers, calculate workflow steps
    getSignerInfo() {
        let that = this;
        if (typeof this.sessionService.info === 'undefined') {
            return;
        }

        console.debug('getSignerInfo');
        that.httpService.getAllSigners(that.sessionId!).toPromise()
            .then(function (response) {

                if (response && response.success) {

                    // tests if some evidences are required
                    that.signers = response.result;

                    if (that.signers) {
                        for (var i = 0; i < that.signers.length; i++) {

                            console.log(that.signers)
                            var promise = that.httpService.getAllEvidences(that.sessionId!, that.signers[i].extSignerId).toPromise().then(function (response) {
                                if (response?.result) {
                                    that.requiresEvidences = that.requiresEvidences || (response.result as Array<EvidenceDto>).length > 0;
                                }
                            });
                            that.evidenceRequirementVerifications.push(promise);
                        }
                    }

                    forkJoin(that.evidenceRequirementVerifications).subscribe({
                        next: () =>// success
                        {

                            that.rootScope.get().steps = [];

                            if (that.requiresEvidences) {
                                that.rootScope.get().steps.push(Steps.evidences);
                            }
                            that.rootScope.get().steps.push(Steps.agreements);
                            that.rootScope.get().steps.push(Steps.signatures);

                            if (that.rootScope.get().properties.summaryPage !== 'redirection') {
                                that.rootScope.get().steps.push(Steps.resume);
                            }
                            console.log("next get evidences");
                        }, error: () => {
                            console.log("error get evidences");
                            that.rootScope.get().steps = [
                                Steps.evidences,
                                Steps.agreements,
                                Steps.signatures,
                                Steps.resume];
                        }
                    });
                } else {
                    console.log("evidences response ", response);
                    //handle session errors here ## tricky
                    if (response && response.error && response.error.errorCode === 8) {
                        that.redirectionService.error(that.route, CustomErrors.invalidSession, CustomErrors.invalidSession);
                    } else {
                        that.redirectionService.error(that.route, CustomErrors.unexpectedError, that.sessionId);
                    }
                }
            }, function () {
                // If process error
                that.redirectionService.error(that.route, CustomErrors.unreachableService, that.sessionId);

            });
    }

    getSigners() {
        let that = this;
        console.debug('Getting signers for ' + this.sessionId);

        this.httpService.getAllSigners(this.sessionId!).toPromise()
            .then(function (response) {
                    console.log("getallsigners = ",response)

                    if (response && response.success) {
                        // If no error

                        // Save signers
                        that.signerService.signers = response.result;
                        that.chooseSigner();

                        if (that.signerService.currentSigner) {

                            console.debug('current signer status : ', that.signerService.currentSigner.externalSignerStatus);

                            switch (that.signerService.currentSigner.externalSignerStatus) {
                                case ExternalSignerStatusEnum.Evidences:
                                    console.info('redirection to evidences');
                                    that.redirectionService.evidences(that.route, that.sessionId);
                                    break;
                                case ExternalSignerStatusEnum.Agreements:
                                    console.info('redirection to agreement');
                                    if (sessionStorage.getItem('sessionType') && sessionStorage.getItem('sessionType') === 'smartphone') {
                                        console.info('Agreement Signer Status for smartphone');
                                        that.redirectionService.smartphoneagreements(that.route, that.sessionId, that.shortId);
                                    } else {
                                        console.info('Agreement Signer Status for non-smartphone');
                                        that.redirectionService.agreements(that.route, that.sessionId);
                                    }
                                    break;
                                case ExternalSignerStatusEnum.PendingSignature:
                                    console.info('redirection to pendingSignature');
                                    that.redirectionService.pendingSignature(that.route, that.sessionId);
                                    break;
                                case ExternalSignerStatusEnum.CertificateApproval:
                                case ExternalSignerStatusEnum.Signatures:
                                    console.info('redirection to signature');
                                    that.redirectionService.signatures(that.route, that.sessionId);
                                    break;
                                case ExternalSignerStatusEnum.PendingCancellation:
                                    console.info('redirection to pendingCancellation');
                                    that.redirectionService.error(that.route, CustomErrors.cancellationError, that.sessionId);
                                    break;
                                default:
                                    // Log the error and redirect
                                    console.warn('invalid externalSignerStatus : ' + that.signerService.currentSigner.externalSignerStatus);
                                    that.redirectionService.error(that.route, CustomErrors.unexpectedError, that.sessionId);
                                    break;
                            }
                        } else {
                            console.debug('All signers had already signed all their documents, but the session is not at the status completed');
                            console.debug("properties = ", that.rootScope.get().properties)
                            switch (that.rootScope.get().defaultProperties.summaryPage) {
                                case 'redirection':
                                    console.info('redirection to page exit');
                                    that.redirectionService.exit(that.sessionService.getUrlOk());
                                    break;
                                case 'redirectionPage':
                                    console.info('redirection to transientSummary');
                                    that.redirectionService.transientSummary(that.route, that.sessionId);
                                    break;
                                case 'page':
                                    console.info('redirection to page summary');
                                    that.redirectionService.summary(that.route, that.sessionId);
                                    break;
                                default:
                                    console.info('redirection to summary default');
                                    that.redirectionService.summary(that.route, that.sessionId);
                                    break;
                            }

                        }

                    } else {
                        // If process error
                        // Log the error and redirect
                        console.warn(response ? response.error : '');
                        that.redirectionService.error(that.route, CustomErrors.unexpectedError, that.sessionId);
                    }
                },
                function () {
                    // If communication error
                    that.errorMsg = 'error.unreachable';
                    that.redirectionService.error(that.route, CustomErrors.unreachableService, that.sessionId);
                });
    }

    // Choose the first signer which have not finish his process
    chooseSigner() {
        let that = this;
        console.debug('choosing signer');
        if (!that.signerService.signers) {
            console.debug('signers is undefined');
            return;
        }

        that.signerService.currentSigner = undefined;

        // In a first time, choose a signer with the status
        // evidences

        forEach(that.signerService.signers, function (signer) {
            console.log("signer = ",signer);
            if (!that.signerService.currentSigner) {
                switch (signer.externalSignerStatus) {
                    case ExternalSignerStatusEnum.Evidences:
                        that.signerService.currentSigner = signer;
                        return;
                    case ExternalSignerStatusEnum.EvidencesKo:
                    case ExternalSignerStatusEnum.AgreementsKo:
                    case ExternalSignerStatusEnum.CertificateApprovalKo:
                    case ExternalSignerStatusEnum.SignaturesKo:
                        console.debug('A signer has the error status : {0}', [signer.ExternalSignerStatus]);
                        that.signerService.currentSigner = null;
                        return;
                    case ExternalSignerStatusEnum.Agreements:
                    case ExternalSignerStatusEnum.CertificateApproval:
                    case ExternalSignerStatusEnum.PendingSignature:
                    case ExternalSignerStatusEnum.Signatures:
                    case ExternalSignerStatusEnum.Completed:
                    case ExternalSignerStatusEnum.PendingCancellation:
                        // Go to the next signer
                        break;
                    default:
                        // Log the error and redirect
                        console.warn('invalid externalSignerStatus : {0}', [signer.externalSignerStatus]);
                        that.signerService.currentSigner = null;
                        return;
                }
            }
        });

        // In a second time, choose a signer with an other status
        if (!that.signerService.currentSigner) {
            forEach(that.signerService.signers, function (signer) {
                if (!that.signerService.currentSigner) {
                    switch (signer.externalSignerStatus) {
                        case ExternalSignerStatusEnum.Evidences:
                        case ExternalSignerStatusEnum.Agreements:
                        case ExternalSignerStatusEnum.CertificateApproval:
                        case ExternalSignerStatusEnum.PendingSignature:
                        case ExternalSignerStatusEnum.Signatures:
                        case ExternalSignerStatusEnum.PendingCancellation:
                            that.signerService.currentSigner = signer;
                            return;
                        case ExternalSignerStatusEnum.EvidencesKo:
                        case ExternalSignerStatusEnum.AgreementsKo:
                        case ExternalSignerStatusEnum.CertificateApprovalKo:
                        case ExternalSignerStatusEnum.SignaturesKo:
                            that.signerService.currentSigner = null;
                            return;
                        case ExternalSignerStatusEnum.Completed:
                            // Go to the next signer
                            break;
                        default:
                            // Log the error and redirect
                            console.warn('invalid externalSignerStatus : {0}', [signer.externalSignerStatus]);
                            that.signerService.currentSigner = null;
                            return;
                    }
                }
            });
        }
    }

}
